import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import React from "react";
import { notifySomething } from "../_Utils/AppDocuCommon";
import AppDocuServiceCall from "../_Utils/AppDocuServiceCall";
import VehicleDialogForm from "./_VehicleDialogForm";

export default class AddVehicleDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      itemData: AddVehicleDialog.getInitialItemData(),
    };
  }

  static getInitialItemData() {
    return {
      brand: '',
      model: '',
      description: '',
      engine_code: '',
      cylinders: '4',
      displacement: '0',
      power: '0',
      euro_code: '',
      petrol_ecu: '',
      internal_notes: '',
      user_notes: '',
      status: '',
    };
  }

  addMachineService = async (itemData) => {
    try {
      const res = await AppDocuServiceCall.createVehicle(itemData);
      if (res.data && res.data.is_valid === false) {
        notifySomething(res.data.message || 'Error adding vehicle', 'error');
        return;
      }
      await this.props.onItemsChange(); // Refresh the machines list after adding !!!
      this.props.onClose(); // Close the dialog after adding !!!
    } catch (error) {
      console.error('Error adding vehicle:', error);
      notifySomething('Error adding vehicle', 'error');
    }
  };
    
  handleAdd = async () => {
    const m = this.state.itemData || {};
    const data = {
      ...m,
      brand: m.brand || '',
      model: m.model || '',
      description: m.description || '',
      engine_code: m.engine_code || '',
      cylinders: m.cylinders || '0',
      displacement: m.displacement || '0',
      power: m.power || '0',
      euro_code: m.euro_code || '',
      petrol_ecu: m.petrol_ecu || '',
      internal_notes: m.internal_notes || '',
      user_notes: m.user_notes || '',
      status: m.status || '',
    };
    // Conversione numerica per i campi numerici
    data.power = data.power ? Number(data.power) : 0;
    data.cylinders = data.cylinders ? Number(data.cylinders) : 0;
    data.displacement = data.displacement ? Number(data.displacement) : 0;
    // Call the service to add the machine
    await this.addMachineService(data)
  };

  componentDidUpdate(prevProps) {
    // Reset fields when dialog is opened
    if (this.props.isOpen && !prevProps.isOpen) {
      this.setState({ itemData: AddVehicleDialog.getInitialItemData() });
    }
  }

  render() {
    return (
      <Dialog open={!!this.props.isOpen} onClose={this.props.onClose} maxWidth="xl" fullWidth>
        <DialogTitle>Add New Vehicle</DialogTitle>
        <DialogContent sx={{ overflowY: 'auto', overflow: 'visible' }}>
          <VehicleDialogForm
            itemData={this.state.itemData}
            onChange={newData => this.setState({ itemData: newData })}
            disabled={false}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={this.props.onClose}>Cancel</Button>
          <Button onClick={this.handleAdd} color="primary">Add</Button>
        </DialogActions>
      </Dialog>
    );
  }
}
